export default {
    UPDATE_DOD_REVIEW_FIELD: 'UPDATE_DOD_REVIEW_FIELD',
    UPDATE_DOD_REVIEW_TITLE: 'UPDATE_DOD_REVIEW_TITLE',
    DOD_REVIEW_CAPTCHA_RESET: 'DOD_REVIEW_CAPTCHA_RESET',
    DOD_REVIEW_CAPTCHA_PENDING: 'DOD_REVIEW_CAPTCHA_PENDING',
    DOD_REVIEW_CAPTCHA_SUCCESS: 'DOD_REVIEW_CAPTCHA_SUCCESS',
    DOD_REVIEW_CAPTCHA_FAILURE: 'DOD_REVIEW_CAPTCHA_FAILURE',
    DOD_REVIEW_CAPTCHA_VALIDATION_RESET: 'DOD_REVIEW_CAPTCHA_VALIDATION_RESET',
    DOD_REVIEW_CAPTCHA_VALIDATION_PENDING: 'DOD_REVIEW_CAPTCHA_VALIDATION_PENDING',
    DOD_REVIEW_CAPTCHA_VALIDATION_SUCCESS: 'DOD_REVIEW_CAPTCHA_VALIDATION_SUCCESS',
    DOD_REVIEW_CAPTCHA_VALIDATION_FAILURE: 'DOD_REVIEW_CAPTCHA_VALIDATION_FAILURE',
    DOD_REVIEW_SUBMISSION_RESET: 'DOD_REVIEW_SUBMISSION_RESET',
    DOD_REVIEW_SUBMISSION_PENDING: 'DOD_REVIEW_SUBMISSION_PENDING',
    DOD_REVIEW_SUBMISSION_SUCCESS: 'DOD_REVIEW_SUBMISSION_SUCCESS',
    DOD_REVIEW_SUBMISSION_FAILURE: 'DOD_REVIEW_SUBMISSION_FAILURE',
    DOD_REVIEW_TOGGLE_SUBMISSION_MODAL: 'DOD_REVIEW_TOGGLE_SUBMISSION_MODAL',
    DOD_REVIEW_SET_MODAL_VIEW: 'DOD_REVIEW_SET_MODAL_VIEW',
    DOD_REVIEW_SUBMISSION_BUILDING: 'DOD_REVIEW_SUBMISSION_BUILDING',
    DOD_REVIEW_SUBMISSION_RESET: 'DOD_REVIEW_SUBMISSION_RESET',
    DOD_REVIEW_SUBMISSION_PENDING: 'DOD_REVIEW_SUBMISSION_PENDING',
    DOD_REVIEW_SUBMISSION_SUCCESS: 'DOD_REVIEW_SUBMISSION_SUCCESS',
    DOD_REVIEW_SUBMISSION_FAILURE: 'DOD_REVIEW_SUBMISSION_FAILURE'
}
